import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';

export const useDeviceId = (): string => {
  const history = useHistory();
  return useMemo(() => {
    const search = history.location.search || '';
    const params = new URLSearchParams(search);
    let id = params.get('deviceId');
    if (id == null && search) {
      const first = search.slice(1).split('&')[0];
      id = first.includes('=') ? first.replace(/^[^=]+=/, '') : first;
    }
    if (id == null) id = window?.DeviceApi?.getDeviceId() ?? '';
    const out = (id || '').trim();
    window.DeviceApi.getDeviceId = () => out;
    return out;
  }, [history]);
};
